import { useSelector } from 'react-redux';
import { selectDatesFilter } from 'shared/selectors/filters';
import { useDatesChangeHandler } from 'shared/containers/DatesContainer/hooks';
import { FC } from 'react';

import { Calendar } from '../../../../../../../packages/Calendar';
import { AdvancedFilterRow } from 'shared/components/AdvancedFilter';

export const DatesContainer: FC = () => {
  const {
    label,
    value: { from, to },
    min,
    max,
  } = useSelector(selectDatesFilter);

  const onChange = useDatesChangeHandler();

  return (
    <AdvancedFilterRow label={label}>
      <Calendar minDate={min} maxDate={max} fromValue={from} toValue={to} onChange={onChange} />
    </AdvancedFilterRow>
  );
};
